import { url } from '../../../api/endpointURL';
import React, { useState } from 'react';

// error notification box
import './edit-modal.css';

// Import generic components
import Button from '../../../generic_components/Button/Button';
import Input from '../../../generic_components/Input/Input';
import { useToast } from '../../../generic_components/Toast/Toast';

const EditSIModal = ( {hwid, closeModal, site, setTableData, tableData} ) => {
    const [si, setSI] = useState('');
    const[loading, setLoading] = useState(false);

    const toast = useToast();
        
    const handleUpdateSI = async() => {
        try 
        {
            if (!si.trim()) {
                const errorMsg = `Please enter SI name.`;
                toast.error(errorMsg, {
                    hideProgressBar: true,
                    autoClose: 9000 
                });
                return;
            }
            const data = {hwid, si};
            setLoading(true);
            const response = await fetch(`${url}/edit-si`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();        
        
            if (result.code === 200) {          
                const successMsg = `SI name updated to ${si} successfully.`;
                toast.success(successMsg, {
                    hideProgressBar: true,
                    autoClose: 9000 
                });      
                // update setTableData with the new timezone
                const updatedTableData = tableData.map((item) => {
                    if (item.hwid === hwid) {
                        return { ...item, si: si };
                    }
                    return item;
                });
                setTableData(updatedTableData);
            }
            // add delay of 1 second before closing the modal
            await new Promise(resolve => setTimeout(resolve, 1000));   
            setLoading(false);    
            closeModal();       
        } 
        catch(error) 
        {
            setLoading(false);
            setSI('');
            console.log(`Error in updating SI name : ${error}`);
            const errorMsg = `Interal server error, please try again later.`;
            toast.error(errorMsg, {
                hideProgressBar: true,
                autoClose: 9000    
            });
        }
    }

    const handleSelectChange = (e) => {
        setSI(e.target.value.trim());
    }

  return (
    <div>
        <div className='modal-sites-body-title'>
            Enter a new SI name for the site {site}:
        </div>
    
        <Input
            className='modal-sites-body-input'
            type='text'
            value={si}
            onChange={handleSelectChange} 
            placeholder='Enter SI Name...'
            required 
            disabled={loading}  /* Disable when loading */
        />
        <Button
            size='small' 
            className='modal-sites-body-btn-submit'
            onClick={() => handleUpdateSI()}
            disabled={loading}  /* Disable when loading */
            >
            Update
        </Button>
        
        <div className='modal-sites-body-btn-loading-container'>
            { loading && (
                    <div className='loading-spinner'>
                        <div className="spinner-border modal-sites-body-loading-icon" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )
            }
        </div>        
       
    </div>
    

  )
}

export default EditSIModal